import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useReaderAppMode } from "../lib/readerAppMode";

const Footer = () => {
  const readerApp = useReaderAppMode();
  const { t } = useTranslation();

  return (
    <footer
      className="border-t border-[#EADDD7] bg-white/40 backdrop-blur-sm py-10 px-6"
      data-testid="app-footer"
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6 text-sm">
        <div className="flex items-center gap-2 text-[#5C4B51] shrink-0">
          <div className="h-7 w-7 shrink-0 rounded-full bg-gradient-to-br from-[#D5A8A4] to-[#9B6A6C] flex items-center justify-center">
            <Sparkles className="h-3.5 w-3.5 text-white" />
          </div>
          <span className="font-serif text-base text-[#2C2123]">
            TruBeauté
          </span>
          <span className="text-[#8A7D82] hidden sm:inline">
            {t("footer.tagline")}
          </span>
        </div>

        <nav className="flex flex-wrap items-center gap-x-5 gap-y-3 leading-6 text-[#5C4B51]">
          <Link to="/lessons" className="hover:text-[#9B6A6C] transition-colors">Lessons</Link>
          <Link to="/guides" className="hover:text-[#9B6A6C] transition-colors">Guides</Link>
          <Link to="/enterprise" className="hover:text-[#9B6A6C] transition-colors">{t("nav.enterprise", { defaultValue: "Enterprise" })}</Link>
          <Link to="/partners" className="hover:text-[#9B6A6C] transition-colors">Partners</Link>
          <Link
            to="/about"
            className="hover:text-[#9B6A6C] transition-colors"
            data-testid="footer-about-link"
          >
            {t("footer.about")}
          </Link>
          {!readerApp && (
            <Link
              to="/pricing"
              className="hover:text-[#9B6A6C] transition-colors"
              data-testid="footer-pricing-link"
            >
              {t("footer.pricing")}
            </Link>
          )}
          <Link
            to="/privacy"
            className="hover:text-[#9B6A6C] transition-colors"
            data-testid="footer-privacy-link"
          >
            {t("footer.privacy")}
          </Link>
          <Link
            to="/terms"
            className="hover:text-[#9B6A6C] transition-colors"
            data-testid="footer-terms-link"
          >
            {t("footer.terms")}
          </Link>
          <Link
            to="/contact"
            className="hover:text-[#9B6A6C] transition-colors"
            data-testid="footer-contact-link"
          >
            {t("footer.contact")}
          </Link>
          <Link to="/editorial-standards" className="hover:text-[#9B6A6C] transition-colors">Editorial standards</Link>
          <Link
            to="/support"
            className="hover:text-[#9B6A6C] transition-colors"
            data-testid="footer-support-link"
          >
            {t("footer.support")}
          </Link>
          <Link
            to="/settings"
            className="hover:text-[#9B6A6C] transition-colors"
            data-testid="footer-settings-link"
          >
            {t("footer.privacyData")}
          </Link>
        </nav>
      </div>

      <p className="max-w-6xl mx-auto mt-6 text-xs text-[#8A7D82] text-center sm:text-left">
        {t("footer.amazonNote")}
      </p>
    </footer>
  );
};

export default Footer;
